/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Faq_A3Inputs */

const en_formatter_faq_a3 = /** @type {(inputs: Formatter_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The formatter requires valid JSON input. If your JSON has syntax errors, an error message will indicate what needs to be fixed.`)
};

const ko_formatter_faq_a3 = /** @type {(inputs: Formatter_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아닙니다. 포맷터는 유효한 JSON 입력이 필요합니다. JSON에 구문 오류가 있으면 수정이 필요한 부분을 알려주는 오류 메시지가 표시됩니다.`)
};

const ja_formatter_faq_a3 = /** @type {(inputs: Formatter_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。フォーマッターには有効なJSON入力が必要です。シンタックスエラーがある場合は、修正が必要な箇所を示すエラーメッセージが表示されます。`)
};

/**
* | output |
* | --- |
* | "No. The formatter requires valid JSON input. If your JSON has syntax errors, an error message will indicate what needs to be fixed." |
*
* @param {Formatter_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_faq_a3 = /** @type {((inputs?: Formatter_Faq_A3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Faq_A3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_faq_a3(inputs)
	if (locale === "ko") return ko_formatter_faq_a3(inputs)
	return ja_formatter_faq_a3(inputs)
});